module.exports = __webpack_public_path__ + "static/media/S (143).bbe1e713.jpg";